/**
 * Rotas públicas/de login da API (AutenticacaoController) que tratam o próprio 401 e por isso ficam
 * fora do redirecionamento automático para o login. MinhaConta, AlterarSenha, UsuariosTroca e
 * TrocarUsuario NÃO entram: com token vencido elas voltam ao login como qualquer outra tela
 * (revisão de 08/10/2026 do plano de 07/10/2026).
 */
const ROTAS_AUTENTICACAO_SEM_REDIRECIONAMENTO =
  /(^|\/)Autenticacao\/(Login|SolicitarNovaSenha|DadosNovaSenha|DefinirSenha|MinhaSessao|ObterTokenViaHashId)(\/|\?|$)/i;

export function ehRotaDeAutenticacaoSemRedirecionamento(url: string | undefined | null): boolean {
  return ROTAS_AUTENTICACAO_SEM_REDIRECIONAMENTO.test(url ?? "");
}
